module.exports = __webpack_public_path__ + "media/images/newbies-rocket_people-4f1d692991d1f98d91022e8cb5b6ccd7.svg";